import logger from "./logger"
import * as Sentry from "@sentry/browser"
import Configs from "./publicRuntimeConfig"

import { useEffect } from "react"

export function useScope(scopeName) {
  useEffect(() => {
    Sentry.configureScope((scope) => {
      scope.setTag("service_level", scopeName)
    })
  }, [])
}

export function sentryException(err, extra, skipLogging = false) {
  console.log({ err, extra, skipLogging })
  Sentry.withScope((scope) => {
    if (extra) {
      for (const key in extra) {
        scope.setExtra(key, extra[key])
      }
    }
    scope.setLevel(Sentry.Severity.Error)
    Sentry.captureException(err)
    if (!skipLogging && !Configs.sentryDSN) {
      logger.error(err.message, extra)
    }
  })
}
